import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-play-pause-icon.css?inline';
import '../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-play-pause-icon';

@customElement(CName)
export class UIPlayPauseIcon extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) class = '';
  @property({ type: Boolean }) shouldDisplayPauseIcon = false;

  render() {
    const iconID = this.shouldDisplayPauseIcon ? 'pause-icon' : 'play-icon';
    return html`
      <ui-sprite-svg class="play-pause-icon ${this.class}" .iconID=${iconID}></ui-sprite-svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPlayPauseIcon;
  }
}
